import React from 'react';
import { useStyles } from './styles';
import { Typography, Box, IconButton } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';

export const DocumentsRequiredPopup = (props) => {

  const classes = useStyles();
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props?.handleClose} open={true}>
     
      <Box className={classes.root}>
        <IconButton className={classes.iconStyle} onClick={props.handleClose}>
          <CancelIcon />
        </IconButton>

        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Document Instructions</Typography>
        </Box>
    
        <Box className={classes.contentBody}>
          <Box className={classes.content} dangerouslySetInnerHTML={{ __html: props.lmaPopupContent.contentValue }}></Box> 
        </Box>
    
      </Box> 
    </Dialog>
  )

}
